/* src/app/modules/shared/components/spinner/spinner.component.scss */
:host {
  text-align: center;
}
:host mat-progress-spinner {
  margin: 20px auto 30px;
}
/*# sourceMappingURL=spinner.component.css.map */
